<template>
  <TableLayout :permissions="['business:demandrecord:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="应用名称" prop="applicationName">
        <el-input v-model="searchForm.applicationName" placeholder="请输入应用名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="需求提出者" prop="linkName">
        <el-input v-model="searchForm.linkName" placeholder="请输入需求提出者姓名" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="提交时间" prop="createDate">
          <el-date-picker
              v-model="time"
              type="daterange"
              range-separator="至"
              @change="getTime"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button type="primary" :loading="isWorking.export" v-permissions="['business:demandrecord:exportExcel']" @click="exportExcel">导出</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
<!--      <ul class="toolbar" v-permissions="['business:demandrecord:create']">-->
<!--        <li><el-button type="primary" @click="$refs.operaDemandRecordWindow.open('新建需求记录')" icon="el-icon-plus" v-permissions="['business:demandrecord:create']">新建</el-button></li>-->
<!--      </ul>-->
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="applicationName" label="应用名称" min-width="100px"></el-table-column>
        <el-table-column prop="companyName" label="需求企业" min-width="100px"></el-table-column>
        <el-table-column prop="linkName" label="联系人姓名" min-width="100px"></el-table-column>
        <el-table-column prop="linkPhone" label="联系人电话" min-width="100px"></el-table-column>
        <el-table-column prop="details" label="描述" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="提交时间" min-width="100px"></el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaDemandRecordWindow ref="operaDemandRecordWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaDemandRecordWindow from '@/components/business/OperaDemandRecordWindow'
export default {
  name: 'DemandRecord',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaDemandRecordWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        applicationName: '',
        linkName: '',
        startDate: '',
        endDate: ''
      },
      time: []
    }
  },
  created () {
    this.config({
      module: '需求记录',
      api: '/business/demandRecord',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    getTime(e) {
      if (e && e.length > 0) {
        this.searchForm.startDate = e[0]
        this.searchForm.endDate = e[1]
      } else {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      }
      this.search()
    }
  }
}
</script>
